<template>
  <!-- Mirrored by _content_footer_html in backend/app.py -->
  <footer class="guide-footer">
    <p>
      DRP CONSULTING &middot; KVK: 85650595 &middot;
      <router-link :to="`${prefix}/about`">{{ labels.navAbout }}</router-link> &middot;
      <router-link :to="`${prefix}/contact`">{{ labels.navContact }}</router-link> &middot;
      <router-link :to="`${prefix}/privacy`">{{ labels.privacy }}</router-link>
    </p>
    <p v-if="writingNote" class="footer-note">{{ writingNote }}</p>
  </footer>
</template>

<script>
import { contentLabels } from '../contentPages';
import { localeInfo, localePrefix } from '../i18n/locales';

export default {
  computed: {
    labels() {
      return contentLabels(this.$locale);
    },
    prefix() {
      return localePrefix(this.$locale);
    },
    writingNote() {
      return localeInfo(this.$locale).writingNote;
    }
  }
};
</script>
